import { render } from "./pengaturan-surat.vue?vue&type=template&id=b2492b84&scoped=true"
import script from "./pengaturan-surat.vue?vue&type=script&lang=js"
export * from "./pengaturan-surat.vue?vue&type=script&lang=js"

import "./pengaturan-surat.vue?vue&type=style&index=0&id=b2492b84&lang=scss&scoped=true"

import exportComponent from "/Users/mymac/Documents/Digitala/Perki/newest-perki/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2492b84"]])

export default __exports__